import { createRouter, ErrorComponentProps } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { queryClient } from '@/lib/queryClient.ts';
import { QueryClient } from '@tanstack/react-query';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay.tsx';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/common/components/ui/button';
import { RefreshCw } from 'lucide-react';

const ErrorComponent = (props: ErrorComponentProps) => (
  <ErrorDisplay
    message={props.error.message}
    actions={
      <Button onClick={() => window.location.reload()}>
        <RefreshCw className="mr-2 h-4 w-4" />
        <Trans>Reload page</Trans>
      </Button>
    }
  />
);

export interface AppRouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultErrorComponent: ErrorComponent,
  defaultPendingMs: 700,
  notFoundMode: 'root',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
